import { render } from "./GPTGettingDumber.vue?vue&type=template&id=701d012e"
import script from "./GPTGettingDumber.vue?vue&type=script&lang=js"
export * from "./GPTGettingDumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__